module.exports = __webpack_public_path__ + "static/media/cat.18555a5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cat.mp4
// module id = +t+x
// module chunks = 1